var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"containerF"}},_vm._l((_vm.items),function(item){return _c('search-item',{key:item._id.$oid,attrs:{"item":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }